import React, { useCallback, useRef } from 'react';
import Modal from 'src/Utils/CssModules/modal.module.css';
import Button from '../Button/Button';
import './SmallDialog.css'
import useOutsideClick from 'src/Utils/Hooks/UseOutSideClick/UseOutSideClick';
import { useTranslation } from 'react-i18next';
import ReactDOM from 'react-dom';
export interface ISmallDialogParams {
    title: string
    children: React.ReactNode,
    onSubmit: () => void,
    onClose: () => void,
    submitButtonText?: string;
    submitButtonColor?: string;
    cancelButtonText?: string;
    cancelButtonColor?: string;
    hideCancelButton?:boolean;
    hideSubmitButton?:boolean;
    width?: string;
}
const SmallDialog: React.FC<ISmallDialogParams> = ({ title, 
     children,
     onSubmit, 
     onClose, 
     submitButtonText = 'Submit', 
     submitButtonColor, 
     cancelButtonText, 
     cancelButtonColor, 
     hideCancelButton = false,
     hideSubmitButton = false,
     width,
    }) => {

    const wrapperRef = useRef<HTMLDivElement>(null);
    let cancelBtTxt = cancelButtonText?? 'Cancel';
    const { t } = useTranslation();

    useOutsideClick(wrapperRef, () => { close()})
    const close = useCallback(() => {
        onClose();
    }, [onClose]);
    const submit = useCallback(() => {
        onSubmit();
    }, [onSubmit]);
    return ReactDOM.createPortal(
        <div className='row'>
            <div id="myModal" className={`${Modal.modal}`} style={{ display: 'block', zIndex: 1003 }}>
                <div className={`${Modal.content} ${width ? '' : 'smallcontent' }`} style={{width:`${width}`}} ref={wrapperRef}>
                    <div className={Modal.header} style={{ textAlign: 'center' }}>
                        <h3 style={{fontWeight:'600'}}>{t(title)}</h3>
                    </div>
                
                    <div className={Modal.body} style={{padding:'1px 30px 0px 40px'}}>
                        {children}
                    </div>
                
                    <div className={Modal.footer} style={{padding:'20px 17px 20px 31px'}}>
                        <div className="row" >
                            {!hideCancelButton && 
                            <div className='col-6 d-flex justify-content-end'>
                                <Button
                                    backgroundColor='none'
                                    color={cancelButtonColor? cancelButtonColor: 'var(--primary-color)'}
                                    testId='close'
                                    onClick={() => { close() }}
                                    text={cancelBtTxt}
                                    width='141px'
                                    height='48px'
                                    borderRadius='24px'
                                    borderColor={cancelButtonColor? cancelButtonColor: "#D0D0D0"}
                                    />
                                </div>
                           }
                            { !hideSubmitButton && 
                            <div className={`${!hideCancelButton ? 'col-auto me-auto' : 'align-submit-center'}`} >
                                <Button
                                  backgroundColor={submitButtonColor? submitButtonColor: 'var(--primary-gradient)'}
                                  color='white'
                                  testId='ok'
                                  onClick={() => { submit() }}
                                  text={submitButtonText}
                                  width='141px'
                                  height='48px'
                                  borderRadius='24px'
                                />
                            </div>
                            }
  

                        </div>
                    </div>
                </div>
            </div>
        </div>, document.body
    )
}
export default SmallDialog;